import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {
    buscarColaboradorAPI, crearFlujoDocumentoEmpleadoAPI, getDataToCrearFlujoDocumentoEmpleadoAPI, getEmpleadoNameAPI,
} from "../../../../consumers/backendApisUrls";
import GenericModal from "../../../../components/modal/GenericModal";
import InputSearchAsync from "../../../../components/modalComponents/InputSearchAsync";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import InputText from "../../../../components/modalComponents/InputText";
import {Div} from "../../../registroMaternidad/modales/components/Components";
import {isNullOrUndefinded} from "../../../../helper/utils";

const SECTION_NAME = "RegistrarFlujoDocumentoEmpleado";
const KEYS = {
    IdEmpleado: "IdEmpleado",
    ExtraData1: "ExtraData1",
    ExtraData2: "ExtraData2",
    ExtraData3: "ExtraData3",
    ExtraData4: "ExtraData4",
    ExtraData5: "ExtraData5",
};

const RegistrarFlujoDocumentoEmpleado = ({ toggleModal, refreshPage, idFlujoDocumento }) => {
  const [formValues, setFormValues] = useState({  });
  const [isSending, setIsSending] = useState(false);
  const [submitForm] = useSubmitForm();
    const [propsInputs] = usePropsInputs(formValues, setFormValues, SECTION_NAME);

    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [executeManageGet] = useManageGetRequest();

    const [dataToCreate, setDataToCreate] = useState();


    const [allDropdowns, setAllDropdowns] = useState([]);
    const [selectProps] = usePropsSelect(
        allDropdowns,
        formValues,
        setFormValues,
        SECTION_NAME
    );

  const handleAction = async () => {
    setIsSending(true);
    const api = crearFlujoDocumentoEmpleadoAPI();
    const payload = getPayload();
    try {
      await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successHandleCallback);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSending(false);
    }
  };

  const getPayload = () => {
    return {
      IdFlujoDocumento: idFlujoDocumento,
      ExtraDataViewModel: {...formValues},
      IdEmpleado: formValues?.IdEmpleado
    }
  }

  const successHandleCallback = async () => {
    toggleModal();
    await refreshPage();
  }

    async function getDataToCreate() {
        try {
            const api = getDataToCrearFlujoDocumentoEmpleadoAPI(idFlujoDocumento);
            await executeManageGet(api, (res) => successCallbackGetDataToCreate(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackGetDataToCreate = (res) => {
        setDataToCreate(res?.data);
        console.log(res?.data)
    }

    useEffect(() => {
        getDataToCreate()
    }, []);

  return (
    <GenericModal titulo="Registrar" showModal={toggleModal} width={"600px"}>
      <div className="modal-body pt-0 pl-0">
          <div className="displayFlexWrap">
              <Div col={12}>
                  <InputSearchAsync typeGet label='Empleado' api={buscarColaboradorAPI}
                                    {...selectProps(KEYS.IdEmpleado)}
                                    direction="column" />
              </Div>

              <Div col={12}>
                  <InputText
                      label={"Documento"}
                      value={dataToCreate?.NombreFlujoDocumento}
                      name={"NombreFlujoDocumento"}
                      direction="column"
                      isDisabled={true}
                  />
              </Div>

              {!isNullOrUndefinded(dataToCreate?.CantidadExtraDatas) &&
                <>
                    {dataToCreate?.CantidadExtraDatas >= 1 &&
                        <Div col={12}>
                            <InputText
                                label={"ExtraData1"}
                                {...propsInputs(KEYS.ExtraData1)}
                                sectionName={SECTION_NAME}
                                direction="column"
                                isRequired={true}
                            />
                        </Div>
                    }

                    {dataToCreate?.CantidadExtraDatas >= 2 &&
                    <Div col={12}>
                        <InputText
                            label={"ExtraData2"}
                            {...propsInputs(KEYS.ExtraData2)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={true}
                        />
                    </Div>
                    }
                    {dataToCreate?.CantidadExtraDatas >= 3 &&
                    <Div col={12}>
                        <InputText
                            label={"ExtraData3"}
                            {...propsInputs(KEYS.ExtraData3)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={true}
                        />
                    </Div>
                    }
                    {dataToCreate?.CantidadExtraDatas >= 4 &&
                    <Div col={12}>
                        <InputText
                            label={"ExtraData4"}
                            {...propsInputs(KEYS.ExtraData4)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={true}
                        />
                    </Div>
                    }
                    {dataToCreate?.CantidadExtraDatas >= 5 &&
                    <Div col={12}>
                        <InputText
                            label={"ExtraData5"}
                            {...propsInputs(KEYS.ExtraData5)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={true}
                        />
                    </Div>
                    }
                </>

              }


          </div>

      </div>
      <div className="modal-footer justify-content-end">
        <button
          className="btn btn-outline-primary generic-button-ficha-outlined mr-2"
          disabled={isSending}
          onClick={() => {
            toggleModal();
          }}>
          Cancelar
        </button>
        <button className="btn btn-primary generic-button-ficha" disabled={isSending} onClick={handleAction}>
          Enviar {isSending && <FontAwesomeIcon icon="spinner" transform="left-9" className="spinner ml-3" />}
        </button>
      </div>
    </GenericModal>
  );
}

export default RegistrarFlujoDocumentoEmpleado